import { useContext, type PropsWithChildren } from 'react';

import { GaugeChartConfigContext } from '../contexts/GaugeChartConfigContext.js';
import type { GaugeChartInternalConfig } from '../types/gauge-chart-config-internal.js';
import type { GaugeChartProps } from '../types/gauge-chart.js';
import { buildGaugeChartConfig } from '../utils/build-gauge-chart-config.js';
import { deserializeConfig } from '../utils/deserialize-config.js';
import { iterateSlots } from '../utils/iterate-slots.js';

export const useGaugeChartConfig = (
  props: PropsWithChildren<GaugeChartProps>,
): GaugeChartInternalConfig => {
  const configContext = useContext(GaugeChartConfigContext);

  const isImportedConfig = typeof configContext === 'string';

  const consumerConfig = isImportedConfig
    ? deserializeConfig(configContext)
    : configContext;

  const slots = iterateSlots(props.children);

  const config = buildGaugeChartConfig(props, consumerConfig, slots);

  return config;
};
